export default {
  'SLModal.default.okText': '完成',
  'SLModal.default.cacelText': '取消',
  'SLModal.info.okText': '我知道了',
  'SLPopconfirm.cancelText': '取消',
  'SLPopconfirm.okText': '确定',
  'SLModal.danger.okText': '删除',
  'SLUpload.dragUploading': '松开鼠标上传',
  'SLUpload.default.image.addImage': '添加图片',
  'SLUpload.default.image.description': '建议尺寸 256 x 116',
  'SLUpload.default.image.restImages': '查看剩余{{len}}张图片',
  'SLUpload.default.image.loading': '上传中...',
  'SLUpload.default.image.fail': '上传失败，请重试',
  'SLUpload.default.image.fail.title': '"{{fileName}}"上传失败',
  'SLUpload.default.image.fail.desc1': '大小不能超过{{max}}MB',
  'SLUpload.default.image.fail.desc2': '上传名称不能超过{{max}}个字数',
  'SLUpload.default.image.fail.desc3': '文件超出了最大分辨率{{limitPx}}MP。请缩减分辨率，然后重试',
  'SLUpload.default.image.fail.desc4': '抱歉！最多只能上传{{maxNum}}张图片！',
  'SLUpload.default.image.delete.title': '确认要删除吗？',
  'SLUpload.default.image.delete.content': '删除后不可恢复。',
  'SLUpload.ALTFormModal.placeholder': '请输入图片ALT属性',
  'SLUpload.ALTFormModal.tip': '编辑图片ALT属性有助搜索引擎优化(SEO)和视障人士体验。',
  'SLUpload.ALTFormModal.title': '编辑图片ALT属性',
  'SLUpload.ALTFormModal.length': '最大不能超过{{max}}个字符',
  'SLUpload.uploadField.errorMsg4': '上传图片失败',
  'SLUpload.uploadField.upload': '上传图片',
  'SLUpload.SLImage.preview.closeText': '关闭',
  'SLUpload.uploadfile.fail': '上传失败',
  'SLUpload.uploadfile.fail1': '文件格式错误',
  'SLUpload.uploadfile.sucess': '上传成功',
  'SLUpload.uploadfile.text1': '上传文件',
  'SLUpload.uploadfile.text2': '仅支持.xlsx .xls.csv格式',
  'SLUpload.uploadfile.progress': '上传中..'
};